import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import PanelsLayout from "components/PanelsLayout";
import EmptyPanel from "components/EmptyPanel";
import { useDebounce } from "use-debounce";
import MessagesRegister from "components/Registry/MessagesRegister";
import { ItemKind } from "dto/IKindItems";
import Button from "components/Button";
import ModalsManagerContext from "contexts/ModalsManager";
import OutgoingView from "./OutgoingView";
import styles from "./styles.module.scss";

// Biuro podawcze. Widok „Przychodzące" (domyślny) — lista przesyłek przychodzących
// zarejestrowanych w biurze podawczym (kind=Parcel, grid MessagesRegister). Widok
// „Wychodzące" (/biuro-podawcze/outgoing) — pełny moduł wychodzących (OutgoingView):
// kategorie (Poczta / Odbiór osobisty / Doręczenie osobiste / e-Doręczenia / ePUAP /
// E-mail / Kurier), 3 podwidoki (Do wysyłki / Karty nadawcze / Zwrotki ZPO),
// wielowybór i karty nadawcze. Dedykowane endpointy (poza DocumentsView).

const BiuroPodawczeModule = () => {
  const { view } = useParams();
  const isOutgoing = view === "outgoing";

  const [searchText, setSearchText] = useState("");
  const [subtitle, setSubtitle] = useState(
    isOutgoing ? "Wychodzące" : "Przychodzące",
  );
  const [debouncedText] = useDebounce(searchText, 300);
  const { modals, setModals } = useContext(ModalsManagerContext);

  const handleChangeSearchBar = (text: string) => setSearchText(text);

  const openWizard = () =>
    setModals({ ...modals, createPostage: true, hide: false });

  const incomingPanel = () => (
    <div className={styles.panel}>
      <div className={styles.topBar}>
        <Button text="Zarejestruj nową przesyłkę" onClick={openWizard} />
      </div>
      <div className={styles.gridWrap}>
        <MessagesRegister
          id="biuro-podawcze"
          kind={ItemKind.Parcel}
          searchText={debouncedText}
          setSubtitle={setSubtitle}
        />
      </div>
    </div>
  );

  const outgoingPanel = () => (
    <div className={styles.panel}>
      <OutgoingView searchText={debouncedText} />
    </div>
  );

  return (
    <PanelsLayout
      title="Biuro podawcze"
      subTitle={subtitle}
      onChangeSearch={handleChangeSearchBar}
      leftPanel={isOutgoing ? outgoingPanel() : incomingPanel()}
      hideRight={true}
      rightPanel={<EmptyPanel />}
      isSearchExpanded={true}
    />
  );
};

export default BiuroPodawczeModule;
